// useExportExcel.ts
import { useCallback } from 'react';
import * as XLSX from 'xlsx';

function useExportExcel<T>(data: T[], filename: string = 'export.xlsx') {
  return useCallback(() => {
    if (!data || data.length === 0) {
      console.error('No data available to export');
      return;
    }

    // Convert data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate and download the Excel file
    XLSX.writeFile(workbook, filename);
  }, [data, filename]);
}

export default useExportExcel;
